import { routesConfig } from '@src/core/routes';
import { DroneFeature, AnalyticsFeature } from '@src/features';
import FleetFeature from '@src/features/fleet';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const Analyst: React.FC = () => {
  return (
    <Routes>
      <Route path="/drones" element={<DroneFeature />} />
      <Route path="/drones/*" element={<DroneFeature />} />
      <Route path="/fleet/*" element={<FleetFeature />} />
      <Route path="/analytics/*" element={<AnalyticsFeature />} />
      <Route path="*" element={<Navigate to={routesConfig.drones} />} />
    </Routes>
  );
};

export default Analyst;